
export const VENUE_LOCATIONS = [
  {
    id: 'main-auditorium',
    name: 'Main Auditorium',
    shortName: 'Auditorium',
    description: 'Ceremonies, opening & closing events',
    lat: 32.9427603185949,
    lng: 74.95547794911984,
    color: '#00F0FF',
  },
  {
    id: 'coe-ground-floor',
    name: 'COE Ground Floor',
    shortName: 'COE Ground',
    description: 'AI Arena & kickoff events',
    lat: 32.94128461186887,
    lng: 74.9547472037391,
    color: '#3B82F6',
  },
  {
    id: 'coe-205-206',
    name: 'COE-205 and 206',
    shortName: 'COE Labs',
    description: 'IoT Nexus Buildathon',
    lat: 32.94130772669857,
    lng: 74.9548022896629,
    color: '#3B82F6',
  },
  {
    id: 'dbms-lab',
    name: 'DBMS Lab / CSE Front',
    shortName: 'DBMS Lab',
    description: 'CSE department computer labs and nearby outdoor staging area',
    lat: 32.94135760803787,
    lng: 74.9547297381275,
    color: '#0EA5E9',
  },
  {
    id: 'lt-4',
    name: 'LT-4',
    shortName: 'LT-4',
    description: 'Dev Tank, Crypto Khazana',
    lat: 32.94094740660419,
    lng: 74.95492704308137,
    color: '#06B6D4',
  },
  {
    id: 'lt-3-lt-4-complex',
    name: 'LT-3 & LT-4 Complex',
    shortName: 'LT Complex',
    description: 'Panel discussions, economics events',
    lat: 32.94094740660419,
    lng: 74.95492704308137,
    color: '#06B6D4',
  },
  {
    id: 'lt-main',
    name: 'LT (Lecture Theater)',
    shortName: 'Main LT',
    description: 'Debates, drama, physics showcase, flash picture',
    lat: 32.94094740660419,
    lng: 74.95492704308137,
    color: '#06B6D4',
  },
  {
    id: 'lt-1',
    name: 'LT-1',
    shortName: 'LT-1',
    description: 'Battleground Royals esports',
    lat: 32.94074203943208,
    lng: 74.95300665367344,
    color: '#06B6D4',
  },
  {
    id: 'ce-block',
    name: 'C1 SoALD (School of Civil Engineering)',
    shortName: 'CE Block',
    description: 'Bridge Building, Civil Engineers I.Q., Raaz Ki Talash, Brainwave Quiz, AutoCAD',
    lat: 32.94060,
    lng: 74.95280,
    color: '#F97316',
  },
  {
    id: 'soald-building',
    name: 'In front of SoALD Building',
    shortName: 'SoALD Front',
    description: 'Scavenger hunt',
    lat: 32.94050,
    lng: 74.95260,
    color: '#FBBF24',
  },
  {
    id: 'arch-block',
    name: 'School of Architecture & Landscape Design',
    shortName: 'Arch Studio',
    description: 'Paper Craft, Pottery, Photography, Wire Art, Open Mic',
    lat: 32.941809422685935,
    lng: 74.95668232916017,
    color: '#F472B6',
  },
  {
    id: 'ee-block',
    name: 'School of Electrical Engineering (C-201 SoECE)',
    shortName: 'EE Block',
    description: 'Circuitrix, RC Car Race, Full-Wave Recti-Fun, Treasure Hunt, Battleground, Breadboard Battle',
    lat: 32.94026058266675,
    lng: 74.95426753365308,
    color: '#FACC15',
  },
  {
    id: 'soece-front',
    name: 'In front of SoECE',
    shortName: 'EE Front',
    description: 'RC Car Race',
    lat: 32.94026058266675,
    lng: 74.95426753365308,
    color: '#FCD34D',
  },
  {
    id: 'me-block',
    name: 'Inside Mechanical Department',
    shortName: 'ME Block',
    description: 'Hydraulic Jack, Robotic Arm, HVAC & 3D Printing',
    lat: 32.9401320073568,
    lng:  74.95383977306274,
    color: '#EF4444',
  },
  {
    id: 'me-outside',
    name: 'Outside Mechanical Department',
    shortName: 'ME Outside',
    description: 'Battle of Submarine',
    lat: 32.9401320073568,
    lng:  74.95383977306274,
    color: '#FB7185',
  },
  {
    id: 'bc-junction',
    name: 'BC Junction',
    shortName: 'BC Junction',
    description: 'Central junction used for outdoor events, stalls and exhibitions',
    lat: 32.94009503936443,
    lng: 74.95407931813159,
    color: '#F59E0B',
  },
  {
    id: 'bt-block',
    name: 'ICMR-Biotech',
    shortName: 'BT Block',
    description: 'Helix Craft, Micro Mystic, BIO events',
    lat: 32.940315618027405,
    lng: 74.95321893869722,
    color: '#22C55E',
  },
  {
    id: 'biotech-lab',
    name: 'Biotech Laboratory',
    shortName: 'BT Lab',
    description: 'Lab Olympics',
    lat: 32.940315618027405,
    lng: 74.95321893869722,
    color: '#34D399',
  },
  {
    id: 'bioinfo-lab',
    name: 'Bioinfo Lab',
    shortName: 'Bioinfo Lab',
    description: 'BIO-Hackathon',
    lat: 32.940315618027405,
    lng: 74.95321893869722,
    color: '#10B981',
  },
  {
    id: 'block-a',
    name: 'Block A-106A',
    shortName: 'Block A',
    description: 'BIO-LOGO event',
    lat: 32.940315618027405,
    lng: 74.95321893869722,
    color: '#059669',
  },
  {
    id: 'soll-building',
    name: 'School of Languages & Literature (SoLL)',
    shortName: 'SoLL',
    description: 'Verses & Voices, NATYAOTSAV, Whisper Challenge, Flash Picture',
    lat: 32.940730055724586,
    lng: 74.95362172237948,
    color: '#EC4899',
  },
  {
    id: 'soll-front',
    name: 'In front of SoLL Building',
    shortName: 'SoLL Front',
    description: 'NATYAOTSAV (Drama) outdoor',
    lat: 32.940730055724586,
    lng: 74.95362172237948,
    color: '#F472B6',
  },
  {
    id: 'b206',
    name: 'B206 (Physics Lab / Hall)',
    shortName: 'B206',
    description: 'Specific classroom B206 used for physics workshops and quizzes',
    lat: 32.94021539416894,
    lng: 74.95373791229365,
    color: '#0EA5A4',
  },
  {
    id: 'lt-in-front',
    name: 'In front of LT',
    shortName: 'LT Front',
    description: 'Accuracy Arena (Physics)',
    lat: 32.94073324916156,
    lng: 74.95300822718504,
    color: '#0EA5E9',
  },
  {
    id: 'd-block',
    name: 'D Block',
    shortName: 'D Block',
    description: 'Classroom block used for mathematics and theory-based events',
    lat: 32.94050607529742,
    lng: 74.95491650562732,
    color: '#6366F1',
  },
  {
    id: 'red-rocks',
    name: 'Red Rocks',
    shortName: 'Red Rocks',
    description: 'Enterprise Hub, outdoor events',
    lat: 32.94158330968037,
    lng: 74.95386828415165,
    color: '#F87171',
  },
  {
    id: 'lt-block',
    name: 'Lecture Theatres (LT)',
    shortName: 'LT Block',
    description: 'Lecture theatres LT-1..LT-4 for quizzes, seminars and competitions',
    lat: 32.94090,
    lng: 74.95240,
    color: '#64748B',
  },
  {
    id: 'soll-block',
    name: 'School of Languages & Literature',
    shortName: 'SoLL',
    description: 'Language events, drama and poetry sessions',
    lat: 32.94100,
    lng: 74.95290,
    color: '#F472B6',
  },
];


/**
 * Maps each event ID → venue ID.
 *
 * TO UPDATE: Just change the venue ID for any event, or add new event IDs
 * when you add events to events.js for 2026.
 */
export const EVENT_VENUE_MAP = {
  // ── Computer Science & Engineering ──────────────────────────────────
  'cse-iotnexus':       'coe-205-206',
  'cse-devtank':        'lt-4',
  'cse-aiarena':        'coe-ground-floor',
  'cse-typinggang':     'dbms-lab',
  'cse-promptwars':     'dbms-lab',
  'cse-cryptokhazana':  'lt-4',

  // ── Biotechnology ───────────────────────────────────────────────────
  'bt-helixcraft':      'bt-block',
  'bt-micromystic':     'bt-block',
  'bt-labolympics':     'biotech-lab',
  'bt-biologo':         'block-a',
  'bt-biohackathon':    'bioinfo-lab',

  // ── Architecture ────────────────────────────────────────────────────
  'arch-kagazkekarigar':   'arch-block',
  'arch-shootyourshot':    'arch-block',
  'arch-mudtomasterpiece': 'arch-block',
  'arch-masterthestage':   'arch-block',
  'arch-taaraakriti':      'arch-block',

  // ── Civil Engineering ───────────────────────────────────────────────
  'ce-bridgebuildingcontest': 'ce-block',
  'ce-civilengineersiq':      'ce-block',
  'ce-raazkitalash':          'soald-building',
  'ce-brainwavequiz':         'ce-block',
  'ce-autocad':               'ce-block',

  // ── Electrical Engineering ──────────────────────────────────────────
  'ee-circuitrix':          'ee-block',
  'ee-rccar':               'soece-front',
  'ee-fullwaverectifun':    'ee-block',
  'ee-treasurehunt':        'ee-block',
  'ee-battlegroundroyals':  'lt-1',
  'ee-breadboardbattle':    'ee-block',

  // ── Electronics & Communication Engineering ─────────────────────────
  'ece-robosoccer':      'ee-block',
  'ece-circuithunt':     'ee-block',
  'ece-pcbmarathon':     'ee-block',
  'ece-robosumo':        'ee-block',
  'ece-circuitdebug':    'ee-block',
  'ece-mazesolver':      'ee-block',

  // ── Mechanical Engineering ──────────────────────────────────────────
  'me-mechnexus':             'me-block',
  'me-scrapcraft':            'bc-junction',
  'me-battlebeneaththewaves': 'me-outside',
  'me-labyrinthprotocol':     'bc-junction',
  'me-hydraulicjack':         'me-block',
  'me-roboticarm':            'me-block',
  'me-hvacanD3dprinting':     'me-block',

  // ── Languages & Literature ──────────────────────────────────────────
  'lang-vaadvivaad':       'lt-main',
  'lang-versesandvoices':  'soll-building',
  'lang-natyaotsav':       'soll-front',
  'lang-folkfury':         'bc-junction',
  'lang-whisperchallenge': 'soll-building',
  'lang-flashpicture':     'lt-main',

  // ── Mathematics ─────────────────────────────────────────────────────
  'math-moneyheist':      'lt-main',
  'math-aidangal':        'd-block',
  'math-mindmaze':        'd-block',
  'math-mathmania':       'd-block',
  'math-horsesstable':    'd-block',
  'math-digitaltreasure': 'd-block',

  // ── Physics ─────────────────────────────────────────────────────────
  'phy-nightskyview':        'red-rocks',
  'phy-phyreelshowdown':     'lt-main',
  'phy-seelabworkshop':      'b206',
  'phy-physicspremierleague':'b206',
  'phy-accuracyarena':       'lt-in-front',

  // ── Economics ───────────────────────────────────────────────────────
  'econ-paneldiscussion':    'lt-3-lt-4-complex',
  'econ-trendtalks':         'lt-3-lt-4-complex',
  'econ-yuvasansad':         'lt-3-lt-4-complex',
  'econ-marketinminutes':    'lt-3-lt-4-complex',
  'econ-enterprisehub':      'bc-junction',

  // ── B.Design ────────────────────────────────────────────────────────
  'bdes-imprintandcreate':   'arch-block',
};

/**
 * Helper: Given departmentEvents from EVENTS_DATA, returns an array of
 * venue objects each containing their assigned events (with dept info).
 *
 * Usage in component:
 *   import { buildVenueEventMap } from '../data/venues';
 *   import { EVENTS_DATA } from '../data/events';
 *   const venueData = buildVenueEventMap(EVENTS_DATA.departmentEvents);
 */
export function buildVenueEventMap(departmentEvents) {
  // Flatten all events with department info
  const allEvents = [];
  departmentEvents.forEach(dept => {
    dept.events.forEach(ev => {
      allEvents.push({
        ...ev,
        department: dept.department,
        shortName: dept.shortName,
        gradient: dept.gradient,
        iconColor: dept.iconColor,
      });
    });
  });

  // Group events by venue
  const venueMap = {};
  VENUE_LOCATIONS.forEach(v => {
    venueMap[v.id] = { ...v, events: [] };
  });

  allEvents.forEach(ev => {
    const venueId = EVENT_VENUE_MAP[ev.id] || 'lt-main';
    if (venueMap[venueId]) {
      venueMap[venueId].events.push(ev);
    }
  });

  // Return only venues that have at least one event
  return Object.values(venueMap).filter(v => v.events.length > 0);
}
